import { isLocalizedRoute } from '~/composables/useAppLocale'

/**
 * Picks the interface language for each page.
 *
 * A marketing page has a URL per language (/pricing, /cs/pricing) and
 * @nuxtjs/i18n takes the language from it; nothing to do here. The first visit
 * redirect and remembering the language read are in plugins/locale.client.ts.
 *
 * Pages with a single URL (the app) are shown in the visitor's language
 * (composables/useAppLocale.ts), except pages marked
 * `definePageMeta({ englishOnly: true })`: those whose main content exists in
 * English only (the blog). Showing their frame in Czech would wrap an English
 * text in Czech headings.
 */
export default defineNuxtRouteMiddleware(async (to) => {
  if (isLocalizedRoute(to)) return
  const appLocale = useAppLocale()
  await appLocale.apply(to.meta.englishOnly ? 'en' : appLocale.preferred())
})
